// extracted by mini-css-extract-plugin
export default {"row":"SettingsRow_row__cTQ1H","label":"SettingsRow_label__uq7fv","child":"SettingsRow_child__zRJ2E"};